import '../../Styles/Partials/TestView.css';
import { useQuizSession } from '../../hooks/useQuizSession';

interface Props {
    resource?: any;
    chatId?: string;
    /** Someone else's shared chat: nothing is written back. */
    readOnly?: boolean;
}

/** Side-panel quiz: every question on one page, graded on the server. */
export default function TestView({ resource = {}, readOnly = false }: Props) {
    const session = useQuizSession(resource.id, { readOnly });
    const { quiz, questions, selections, isGraded } = session;

    if (session.isLoading) {
        return <div className="quiz-container"><p className="quiz-status">Loading quiz...</p></div>;
    }
    if (!quiz) {
        return <div className="quiz-container"><p className="quiz-status">This quiz isn't available.</p></div>;
    }

    return (
        <div className="quiz-container">
            <div className="quiz-questions">
                {questions.map((question, questionIndex) => {
                    const locked = session.isLocked(question);
                    return (
                        <div key={question.id} className="question-container">
                            <h3>Question {questionIndex + 1}</h3>
                            <p>{question.text}</p>
                            <div className="answer-choices">
                                {question.choices.map((choice, index) => {
                                    const isSelected = selections[question.id] === index;
                                    const isCorrect = index === question.correctIndex;
                                    const showResult = isGraded || !!session.revealed[question.id];
                                    const inputId = `${question.id}-choice${index}`;
                                    return (
                                        <div
                                            key={index}
                                            className={`answer-choice ${
                                                showResult && isCorrect ? 'correct-answer' : ''
                                            } ${
                                                showResult && isSelected && !isCorrect ? 'incorrect-answer' : ''
                                            }`}
                                        >
                                            <input
                                                type="radio"
                                                id={inputId}
                                                name={`${quiz._id}-${question.id}`}
                                                value={choice}
                                                checked={isSelected}
                                                onChange={() => session.select(question, index)}
                                                disabled={locked}
                                            />
                                            <label htmlFor={inputId}>{choice}</label>
                                        </div>
                                    );
                                })}
                            </div>
                            {(isGraded || session.revealed[question.id]) && question.explanation && (
                                <p className="quiz-explanation">{question.explanation}</p>
                            )}
                            {!locked && (
                                <button
                                    className="show-answer-btn"
                                    type="button"
                                    onClick={() => session.reveal(question)}
                                >
                                    Show Answer
                                </button>
                            )}
                        </div>
                    );
                })}
            </div>
            <div className="quiz-footer">
                {!isGraded ? (
                    <button
                        className="grade-quiz-btn"
                        onClick={() => void session.submit()}
                        disabled={!session.canSubmit}
                        title={session.canSubmit ? "Submit for grading" : "Answer all questions to grade"}
                    >
                        {session.isSubmitting ? 'Grading...' : 'Grade'}
                    </button>
                ) : (
                    <div className="grade-container">
                        <span>
                            <strong>
                                {session.score} / {questions.length}
                            </strong>
                        </span>
                        {!readOnly && (
                            <button type="button" className="quiz-retake-btn" onClick={() => void session.retake()}>
                                Retake
                            </button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
